import React from 'react';
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';

let FOOTER = styled.footer`
  width: 100%;
  
  /*
  background-image: url(/images/GraphicSection_server_one.jpeg);
  background-position: center 100%;
  background-repeat: no-repeat;
  background-size: cover;
  */
  background-color: #363a3c;
`;
let FooterInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  
  width: 100%;
  height: 100px;
  margin: auto;
  background-color: rgba(0, 0, 0, 0.6);
`;
let FooterInnerInfo = styled.div`

  bottom: 130px;
  width: 840px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
`;
let FooterInnerInfoText = styled.p`
  font-size: 12px;
  letter-spacing: 0;
  line-height: 20px;
  text-align: center;
  color: white;
  padding-left: 10px;
  padding-right: 10px;
  margin: 0px;
`;

function Footer() {
  return (
    <FOOTER className="Footer">
      <FooterInner className="footer-inner">
        <FooterInnerInfo className="footer-info">
          <FooterInnerInfoText className="footer-info-text">
            (주)봄시스템즈 | 대표: 정창윤 | 사업자 등록번호: 215-87-62481 | 주소: 서울특별시 서초구 강남대로8길 16-3
          </FooterInnerInfoText>
          <FooterInnerInfoText className="footer-info-text">
            전화: 070-7633-2815 | E-mail: contact@bomsystems.co.kr
          </FooterInnerInfoText>
        </FooterInnerInfo>
      </FooterInner>
    </FOOTER>
  );
}

export default Footer;
